export const environment = {
    production: true,
    baseHref: '/MCWD',
    apiBase: 'https://mydashgis.com/MCWD',
    debug: true,
};
